import Vue from 'vue';
import helpers from './mixins/helpers'
import VueMask from 'v-mask'
Vue.use(VueMask);
if (document.getElementById('registration')) {
    $(document).ready(function () {
        let countrySelect = $("#register-form-country_id");
        let citySelect = $("#register-form-city_id");
        let orgSelect = $("#register-form-org_id");
        let formNode = $("#registration-form");
        let countries = {
            1: {name: 'Россия', mask: "+7 (\\999) 999-99-99", placeholder: "+7 (999) 999-99-99"},
            2: {name: 'Украина', mask: "+380 99 999 9999", placeholder: "+380 99 999 9999"},
            3: {name: 'Беларусь', mask: "+375 99 999-99-99", placeholder: "+375 99 999-99-99"},
            4: {name: 'Казахстан', mask: "+7 (999) 999 9999", placeholder: "+7 (999) 999 9999"},
            5: {name: 'Азербайджан', mask: "+\\9\\94 (99) 999 99 99", placeholder: "+994 (99) 999 99 99"},
            6: {name: 'Армения', mask: "+374 99 999 999", placeholder: "+374 99 999 999"},
            7: {name: 'Грузия', mask: "+\\9\\95 999 99 99 99", placeholder: "+995 999 99 99 99"},
            8: {name: 'Израиль', mask: "+\\972 99 999 99 99", placeholder: "+972 99 999 99 99"},
            9: {name: 'США', mask: "+1 (999) 999-9999", placeholder: "+1 (999) 999-9999"}
        };
        countrySelect.select2({
            placeholder: "Введите страну",
            theme: 'select-city',
            allowClear: true,
            doReset: true
        });
        citySelect.select2({
            placeholder: "Введите город",
            theme: 'select-city',
            minimumInputLength: 1,
            allowClear: true,
            doReset: true,
            templateResult: function (data) {
                if (data.region) {
                    return data.text + ", " + data.region;
                }

                return data.text;
            },
            ajax: {
                url: "/data/city-list",
                data: function (params) {
                    var query = {
                        q: params.term,
                        country: registration.country
                    };
                    return query;
                },

                cache: true
            }
        });
        orgSelect.select2({
            placeholder: "Введите название организации",
            theme: 'select-city',
            allowClear: true,
            minimumInputLength: 3,
            doReset: true,
            templateResult: function (data) {
                return data.text;
            },
            ajax: {
                url: "/data/org-list",
                data: function (params) {
                    var query = {
                        q: params.term,
                        country: registration.country,
                        city: registration.city,
                        addother: 1
                    };
                    return query;
                },

                cache: true
            }
        });
        citySelect.on('change', function (e) {
            registration.org = null;
            orgSelect.empty();
        });
        countrySelect.on('change', function (e) {
            citySelect.empty();
            orgSelect.empty();
            registration.city = null;
            if (typeof countries[this.value] !== 'undefined') {
                $("#register-form-phone").inputmask({"mask": countries[this.value].mask, clearMaskOnLostFocus: true});
                $("#register-form-phone").attr('placeholder', countries[this.value].placeholder);
                $('#register-form-org_phone').inputmask({
                    "mask": countries[this.value].mask,
                    clearMaskOnLostFocus: true
                });
                $('#register-form-org_phone').attr('placeholder', countries[this.value].placeholder);
            } else {
                $("#register-form-phone").inputmask('remove');
                $("#register-form-phone").removeAttr('placeholder');
                $('#register-form-org_phone').inputmask('remove');
                $("#register-form-org_phone").removeAttr('placeholder');
            }
        });
        $(".search-sity").select2({
            theme: 'select-city',
            allowClear: true,
            doReset: true,
            doToggle: false,
            doOrder: false
        });
        formNode.on('ajaxComplete', function (event, jqXHR, textStatus) {
            let data = jqXHR.responseJSON;
            console.log(registration.step);
            // Warning!!! i know this is very bad code
            if (registration.step > 4) {
                sendEvent.newUser();
            }
            //_______________________________________

            registration.emailValidation = !data.hasOwnProperty('register-form-email') && !data.hasOwnProperty('register-form-phone') && !data.hasOwnProperty('register-form-confirm_sms_code');

            if (registration.phone.number.replace(/[^0-9]+/g, '').length >= 11) {

                registration.phone.phoneValid = !data.hasOwnProperty('register-form-phone');

            }
            registration.phone.confirmNumber = !data.hasOwnProperty('register-form-confirm_sms_code') && registration.phone.sendCode;
        });
        formNode.on('afterValidate', function (e) {
            // Выполнять только при submit-е
            if (formNode.data('yiiActiveForm').submitting === false) {
                return;
            }

            var currentStep = $("#step-" + registration.step);
            var nextStep = $("#step-" + (registration.step + 1));

            if (currentStep.find('.has-error').length === 0) {
                nextStep.find('.has-error').removeClass('has-error');
                nextStep.find('.help-block').html('');
                registration.step++;

            }
        });

    });
    Vue.directive('select2', {
        bind: function (el, binding, node) {
            $(el)
                .on("select2:select", function (e) {
                    registration[binding.expression] = $(this).val();
                })
                .on("select2:unselect", function (e) {
                    registration[binding.expression] = '';
                });
        }
    });
    let registration = new Vue({
        mixins: [helpers],
        el: "#registration",
        data: {
            step: 1,
            country: 1,
            phone: {
                number: '',
                sendCode: false,
                confirmNumber: false,
                phoneValid: false,
                phoneIsRussian: false,
                verifyCode: null,
                codeErrorMessage: null,
                resendCountDown: {
                    interval: null,
                    seconds: null,
                    message: 'Отправить код повторно можно будет через 2 минуты'
                }
            },
            email: '',
            org: null,
            org_region: null,
            city: '',
            errors: false,
            errorStep: false,
            countries: {
                1: {name: 'Россия', mask: "+7 (\\999) 999-99-99", placeholder: "+7 (999) 999-99-99"},
                2: {name: 'Украина', mask: "+380 99 999 9999", placeholder: "+380 99 999 9999"},
                3: {name: 'Беларусь', mask: "+375 99 999-99-99", placeholder: "+375 99 999-99-99"},
                4: {name: 'Казахстан', mask: "+7 (999) 999 9999", placeholder: "+7 (999) 999 9999"},
                5: {name: 'Азербайджан', mask: "+\\9\\94 (99) 999 99 99", placeholder: "+994 (99) 999 99 99"},
                6: {name: 'Армения', mask: "+374 99 999 999", placeholder: "+374 99 999 999"},
                7: {name: 'Грузия', mask: "+\\9\\95 999 99 99 99", placeholder: "+995 999 99 99 99"},
                8: {name: 'Израиль', mask: "+\\972 99 999 99 99", placeholder: "+972 99 999 99 99"},
                9: {name: 'США', mask: "+1 (999) 999-9999", placeholder: "+1 (999) 999-9999"}
            },
            confidentiality: false,
            emailValidation: false,
        },
        methods: {
            nextStep(event) {
                event.preventDefault();
                if (this.phone.confirmNumber === false && this.step === 3 && this.phone.phoneValid === true && this.phone.phoneIsRussian === true) {
                    this.sendCode();
                }
                $('#registration-form').submit();


            },
            phoneValidate(phone) {
                this.phone.number = phone;
                this.phone.phoneValid = false;
                if (registration.phone.number.replace(/[^0-9]+/g, '').length >= 11) {
                    $('#registration-form').yiiActiveForm('validateAttribute', 'register-form-phone');
                }
                let isRussianRE = /^(\+7 \(9[\d]{2}\) [\d]{3}-[\d]{2}-[\d]{2})$/;
                this.phone.phoneIsRussian = isRussianRE.test(registration.phone.number);
            },
            codeValidate(code) {

                this.phone.verifyCode = code;

                if (registration.phone.verifyCode.length >= 4) {

                    $('#registration-form').yiiActiveForm('validateAttribute', 'register-form-confirm_sms_code');

                }
            },
            changeNumber() {
                this.phone.sendCode = false;
                this.phone.phoneValid = false;
                this.phone.verifyCode = null;
            },
            sendCode() {
                let self = this;
                this.phone.resendCountDown.seconds = 120;
                this.phone.sendCode = true;
                clearInterval(this.phone.resendCountDown.interval);

                this.phone.resendCountDown.interval = setInterval(function () {
                    self.resendCountDown();
                }, 1000);
                try {

                    $.ajax({
                        url: '/user/registration/send-confirm-code',
                        dataType: "json",
                        method: 'POST',
                        data: {
                            phone: self.phone.number,
                            _csrf: self.getCsrf()
                        },
                        success: function (data) {},
                        fail: function () {

                            throw new Error('Ошибка получении данных');

                        }
                    });

                } catch (e) {

                    //Отправить данные об ошибке в систему логов

                    console.error(e);

                }

            },
            resendCountDown() {
                let self = this;
                if (this.phone.resendCountDown.seconds === 0) {

                    clearInterval(this.phone.resendCountDown.interval);

                    this.phone.resendCountDown.message = 'Отправить код повторно можно будет через 2 минуты';

                } else {
                    this.phone.resendCountDown.seconds--;
                    var time = new Date(this.phone.resendCountDown.seconds * 1000);
                    var message = 'Отправить код повторно можно будет через ';

                    if (time.getMinutes() > 0) {

                        let minute = time.getMinutes();
                        message += minute + ' ' + self.decOfNum(minute, ['минуту', 'минуты', 'минут']) + ' ';

                    }

                    let seconds = time.getSeconds();

                    message += seconds + ' ' + self.decOfNum(seconds, ['секунду', 'секунды', 'секунд']);


                    this.phone.resendCountDown.message = message;
                }
            },
        },
        mounted() {},
        computed: {
            disabledStep: function () {
                if ((this.emailValidation === true || this.phone.confirmNumber === true)) {
                    return false
                }
                else {
                    return true
                }
            },
            phoneValidation: function () {
                if (this.phone.number.length < 1) {
                    this.phone.phoneValid = false;
                }
                return this.phone.number.length
            },
            showBtn() {
                return (this.phone.sendCode === false && this.phone.phoneValid === true && this.phone.phoneIsRussian === true)
            }
        },
        watch: {
            step(val) {
                if (val === 2 ) {
                    window.sendEvent.regStep_1();
                }
                else if (val === 3) {
                    window.sendEvent.regStep_2();
                }
                else if (val === 4) {
                    window.sendEvent.regStep_3();
                }
            },
        },
    });
}
